import { orderExplorerRootStore } from '../../../order-explorer/stores/order-explorer-root-store';
import { TableDefinition } from '../../stores/groups/table-definition';

function get(): TableDefinition {
	return orderExplorerRootStore.getStore().orderExplorerStore.currentTableDefinition; //todo - BRNGG-19059 support RM table definition
}

export const tableDefinitionGetter = { get };
